import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DoneIcon from '@mui/icons-material/Done';
import Tooltip from '@mui/material/Tooltip';

import classes from './CourseProgress.module.css';

const CourseProgress = props => {
  const { t } = useTranslation(['course']);

  return (
    <>
      {props.activityState === 'finished' ? (
        <Tooltip title={t('finished')}>
          <DoneIcon className={classes.doneIcon} />
        </Tooltip>
      ) : props.activityState === 'started' ? (
        <Tooltip title={t('started')}>
          <div className={classes.wrapper}>
            <div className={classes.one}></div>
            <div className={classes.two}></div>
          </div>
        </Tooltip>
      ) : (
        <Tooltip title={t('without_starting')}>
          {props.icon === 'video' ? (
            <figure className={classes.iconLessonContainer}>
              <img
                className={classes.img}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/Video_icon.png"
              />
            </figure>
          ) : props.icon === 'quiz' ? (
            <figure className={classes.iconLessonContainer}>
              <img
                className={classes.img}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/Evaluacion_icon.png"
              />
            </figure>
          ) : props.icon === 'activity' ? (
            <figure className={classes.iconLessonContainer}>
              <img
                className={classes.img}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/Actividad_icon.png"
              />
            </figure>
          ) : (
            <figure className={classes.iconLessonContainer}>
              <img
                className={classes.img}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/Coevaluacion_icon.png"
              />
            </figure>
          )}
        </Tooltip>
      )}
    </>
  );
};

CourseProgress.propTypes = {
  // eslint-disable-next-line react/require-default-props
  activityState: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  icon: PropTypes.string
};

export default CourseProgress;
